import * as React from 'react';
import { Pagination, PaginationProps } from 'react-admin';

export const DefaultPagination: React.FC<PaginationProps> = (props) => (
  <Pagination {...props} rowsPerPageOptions={[25, 50, 100]} />
);

export const EventPagination: React.FC<PaginationProps> = (props) => (
  <Pagination {...props} rowsPerPageOptions={[25, 50, 100, 500]} />
);
